export default "__VITE_ASSET__DOVKHPGS__"